import axios from "axios";
import { BASE_API_URL } from "../../api";
import {
  PatientTagDTO,
  SpecialituesDiseaseTagDTO,
} from "../../dtos/diseaseTags";
import {
  getAppointmentDetailsDto,
  getClinicPaymentDto,
  getDoctorPaymentDto,
  RefundPaymentDto,
  SpecialituesRegisterDTO,
  VerifyAttachmentsDto,
} from "../../dtos/specialities";
import { SpecialituesTagDTO } from "../../dtos/specialityTags";
import { SpecialityDelDTO } from "../../dtos/spec_deleteDtto";
import {
  AppoimentDTO,
  RevenueDTO,
  TreatmentTagDTO,
} from "../../dtos/treatmentTags";

axios.defaults.withCredentials = true;

const getAllSpeciality = async () => {
  const { data } = await axios.get( "/api/speciality/all");
  return data;
};

const getDashboardDataApi = async () => {
  const { data } = await axios.get( "/api/admin/emareez/stats");

  return data;
};

const getAllPatients = async () => {
  const { data } = await axios.get( "/api/admin/patients");
  return data;
};

const getCreditPatients = async (patient_id: any) => {
  const { data } = await axios.get(
     `/api/admin/patients/wallet/history?patient_id=${patient_id}`
  );
  return data;
};

const getAppoimentPatients = async (appointment_id: any) => {
  const { data } = await axios.get(
    
      `/api/admin/appointment/wallet/history?appointment_id=${appointment_id}`
  );
  return data;
};

const getRefundPatients = async (refund: RefundPaymentDto) => {
  const { data } = await axios.post(
     `/api/admin/appointment/refund-payment`,
    refund
  );
  return data;
};

const getUpComming = async (patient_id: any) => {
  const { data } = await axios.get(
    
      ` api/admin/patients/upcoming-appointments?patient_id=${patient_id}`
  );
  return data;
};

const getClinicPayments = async (specilities: getClinicPaymentDto) => {
  const { data } = await axios.post(
     `/api/admin/clinic/payments/make`,
    specilities
  );
  return data;
};

const VerifyDocAttachments = async (attachment: VerifyAttachmentsDto) => {
  const { data } = await axios.post(
     "/api/admin/doctor/payments/attachment/verify",
    attachment
  );
  return data;
};

const VerifyClinicAttachments = async (attachment: VerifyAttachmentsDto) => {
  const { data } = await axios.post(
     "/api/admin/clinic/payments/attachment/verify",
    attachment
  );
  return data;
};

const getDoctorPayments = async (specilities: getDoctorPaymentDto) => {
  const { data } = await axios.post(
     `/api/admin/doctor/payments/make`,
    specilities
  );
  return data;
};
const getAppointmentDetails = async (specilities: getAppointmentDetailsDto) => {
  const { data } = await axios.get(
    
      `/api/admin/appointment/data/get?start_date=${specilities.start_date}&end_date=${specilities.end_date}&doctor_id=${specilities.doctor_id}&clinic_id=${specilities.clinic_id}`
  );
  return data;
};
const getApoHistory = async (patient_id: any) => {
  const { data } = await axios.get(
    
      `/api/admin/patients/appointment/history?patient_id=${patient_id}`
  );
  return data;
};

const getOnlineApo = async (patient_id: any) => {
  const { data } = await axios.get(
    
      `/api/admin/patients/online-upcoming-appointments?patient_id=${patient_id}`
  );
  return data;
};

const registerSpecilities = async (specilities: SpecialituesRegisterDTO) => {
  const { data } = await axios.post(
     "/api/speciality/add",
    specilities
  );
  return data;
};

const editspecilities = async (specilities: SpecialituesRegisterDTO) => {
  const { data } = await axios.post(
     "/api/speciality/update",
    specilities
  );
  return data;
};

const deletespecilities = async (dto: SpecialityDelDTO) => {
  const { data } = await axios.delete(
     `/api/speciality/delete?spec_id=${dto.spec_id}`
  );
  return data;
};

export const getTags = async (speciality_id: string) => {
  const { data } = await axios.get(
     `/api/tags/speciality/get?speciality_id=${speciality_id}`
  );
  return data;
};

const AddTags = async (speciality: SpecialituesTagDTO) => {
  const { data } = await axios.post( `/api/tags/add`, speciality);

  return data;
};

const DeleteTags = async (dto: SpecialituesTagDTO) => {
  const { data } = await axios.delete(
     `/api/tags/delete?tag_id=${dto.tags_id}`
  );
  return data;
};

export const DiseaseGetTags = async (speciality_id: string) => {
  const { data } = await axios.get(
     `/api/disease/speciality/get?speciality_id=${speciality_id}`
  );
  return data;
};

export const PatientGetTags = async (dto: PatientTagDTO) => {
  const { data } = await axios.get(
    
      `/api/admin/patient/pre-condition/get?patient_id=${dto.patient_id}`
  );
  return data;
};

const DiseaseAddTags = async (Disease: SpecialituesDiseaseTagDTO) => {
  const { data } = await axios.post( `/api/disease/add`, Disease);

  return data;
};

const patientAddTags = async (patient_id: any) => {
  const { data } = await axios.post(
    
      `/api/admin/patient/pre-condition/get?patient_id=${patient_id}`
  );

  return data;
};

const DiseaseDeleteTags = async (dto: SpecialituesDiseaseTagDTO) => {
  const { data } = await axios.delete(
     `/api/disease/delete?disease_id=${dto.disease_id}`
  );
  return data;
};
export const TreatmentGetTags = async (speciality_id: string) => {
  const { data } = await axios.get(
    
      `/api/treatment/speciality/get?speciality_id=${speciality_id}`
  );
  return data;
};

const TreatmentAddTags = async (Treatment: TreatmentTagDTO) => {
  const { data } = await axios.post(
     `/api/treatment/add`,
    Treatment
  );

  return data;
};
const TreatmentDeleteTags = async (dto: TreatmentTagDTO) => {
  const { data } = await axios.delete(
     `/api/treatment/delete?treatment_id=${dto.treatment_id}`
  );
  return data;
};

const getAppoiment = async (doctor: AppoimentDTO) => {
  const { data } = await axios.get(
    
      `/api/admin/emareez/appointment/stats?month=${doctor.month}&year=${doctor.year}`
  );
  return data;
};
const getRevenue = async (doctor: RevenueDTO) => {
  const { data } = await axios.get(
     `/api/admin/emareez/revenue/stats?year=${doctor.year}`
  );

  return data;
};
const SpecialityService = {
  getAllSpeciality,
  registerSpecilities,
  editspecilities,
  deletespecilities,
  getTags,
  AddTags,
  DeleteTags,
  DiseaseGetTags,
  DiseaseAddTags,
  DiseaseDeleteTags,
  TreatmentGetTags,
  TreatmentAddTags,
  TreatmentDeleteTags,
  getAllPatients,
  getUpComming,
  getApoHistory,
  getOnlineApo,
  getDashboardDataApi,
  getAppoiment,
  getRevenue,
  PatientGetTags,
  getCreditPatients,
  getAppoimentPatients,
  getClinicPayments,
  getDoctorPayments,
  patientAddTags,
  getRefundPatients,
  VerifyDocAttachments,
  VerifyClinicAttachments,
  getAppointmentDetails,
};

export default SpecialityService;
